import React from 'react';
import axios from 'axios';
import { buildApiUrl } from '../../config/api';

const BookingDetails = ({ booking, onClose, onUpdate }) => {
    const getHeaders = () => {
        const token = localStorage.getItem('token');
        return {
            'Authorization': `Bearer ${token}`,
            'x-auth-token': token
        };
    };

    const handleStatusUpdate = async (status) => {
        try {
            await axios.patch(buildApiUrl(`/camping/admin/bookings/${booking.id}/status`), { status }, {
                headers: getHeaders()
            });
            onUpdate();
        } catch (error) {
            console.error('Error updating booking:', error);
        }
    };

    const handlePaymentUpdate = async (payment_status) => {
        try {
            await axios.patch(buildApiUrl(`/camping/admin/bookings/${booking.id}/payment`), { payment_status }, {
                headers: getHeaders()
            });
            onUpdate();
        } catch (error) {
            console.error('Error updating payment:', error);
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    return (
        <div className="modal-overlay">
            <div className="modal modal-lg">
                <div className="modal-header">
                    <h3>Booking Details - {booking.booking_id}</h3>
                    <button className="close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="booking-details-content">
                    <div className="details-grid">
                        <div className="detail-section">
                            <h4>Customer Information</h4>
                            <div className="detail-item">
                                <label>Name:</label>
                                <span>{booking.customer_name}</span>
                            </div>
                            <div className="detail-item">
                                <label>Email:</label>
                                <span>{booking.customer_email}</span>
                            </div>
                            <div className="detail-item">
                                <label>Phone:</label>
                                <span>{booking.customer_phone}</span>
                            </div>
                        </div>

                        <div className="detail-section">
                            <h4>Booking Information</h4>
                            <div className="detail-item">
                                <label>Booking ID:</label>
                                <span>{booking.booking_id}</span>
                            </div>
                            <div className="detail-item">
                                <label>Created:</label>
                                <span>{formatDate(booking.created_at)}</span>
                            </div>
                            <div className="detail-item">
                                <label>Status:</label>
                                <select 
                                    value={booking.booking_status}
                                    onChange={(e) => handleStatusUpdate(e.target.value)}
                                    className="status-edit"
                                >
                                    <option value="confirmed">Confirmed</option>
                                    <option value="pending">Pending</option>
                                    <option value="cancelled">Cancelled</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>
                        </div>

                        <div className="detail-section">
                            <h4>Camping Site</h4>
                            <div className="detail-item">
                                <label>Site:</label>
                                <span>{booking.site_name}</span>
                            </div>
                            <div className="detail-item">
                                <label>Location:</label>
                                <span>{booking.location_name}</span>
                            </div>
                        </div>

                        <div className="detail-section">
                            <h4>Stay Details</h4>
                            <div className="detail-item">
                                <label>Check-in:</label>
                                <span>{formatDate(booking.check_in)}</span>
                            </div>
                            <div className="detail-item">
                                <label>Check-out:</label>
                                <span>{formatDate(booking.check_out)}</span>
                            </div>
                            <div className="detail-item">
                                <label>Nights:</label>
                                <span>{booking.total_nights}</span>
                            </div>
                            <div className="detail-item">
                                <label>Guests:</label>
                                <span>{booking.guests}</span>
                            </div>
                        </div>

                        <div className="detail-section">
                            <h4>Payment Information</h4>
                            <div className="detail-item">
                                <label>Total Amount:</label>
                                <span className="amount">₹{booking.total_amount}</span>
                            </div>
                            <div className="detail-item">
                                <label>Advance Paid:</label>
                                <span className="amount">₹{booking.advance_amount || 0}</span>
                            </div>
                            <div className="detail-item">
                                <label>Payment Status:</label>
                                <select 
                                    value={booking.payment_status}
                                    onChange={(e) => handlePaymentUpdate(e.target.value)}
                                    className="status-edit"
                                >
                                    <option value="pending">Pending</option>
                                    <option value="completed">Completed</option>
                                    <option value="failed">Failed</option>
                                    <option value="refunded">Refunded</option>
                                </select>
                            </div>
                        </div>

                        {booking.special_requests && (
                            <div className="detail-section full-width">
                                <h4>Special Requests</h4>
                                <div className="special-requests">
                                    {booking.special_requests}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button className="btn-secondary" onClick={onClose}>
                            Close
                        </button>
                        <button 
                            className="btn-primary"
                            onClick={() => window.print()}
                        >
                            <i className="fas fa-print"></i> Print
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingDetails;
